import { Suspense, lazy } from 'react';

import { DynamicBaseBreadcrumb, DynamicProxyServersBreadcrumb } from '../../modules/AppBreadcrumb';
import { Spinner } from '../components';
import { AppControllerType, AppRoutes } from '../interfaces/router';

const ProxyServersListPage = lazy(() => import('../../pages/ProxyServers/ProxyServersList.page'));
const ProxyServersCreatePage = lazy(() => import('../../pages/ProxyServers/ProxyServersCreate.page'));
const ProxyServersEditPage = lazy(() => import('../../pages/ProxyServers/ProxyServersEdit.page'));
const ProxyServersPage = lazy(() => import('../../pages/ProxyServers/ProxyServers.page'));

export const ProxyServersController: AppControllerType = {
  common: [
    {
      path: AppRoutes.ProxyServers + '/*',
      element: (
        <Suspense fallback={ <Spinner/> }>
          <ProxyServersListPage/>
        </Suspense>
      ),
      breadcrumb: DynamicProxyServersBreadcrumb.DynamicProxyServersListBreadcrumb
    }
  ],
  drawer: [
    {
      path: AppRoutes.ProxyServersCreate,
      element: (
        <Suspense fallback={ <Spinner/> }>
          <ProxyServersCreatePage/>
        </Suspense>
      ),
      breadcrumb: DynamicBaseBreadcrumb.DynamicBaseCreateBreadcrumb,
      props: {
        commonDrawerWidth: 480
      }
    },
    {
      path: AppRoutes.ProxyServersByIdEdit,
      element: (
        <Suspense fallback={ <Spinner/> }>
          <ProxyServersEditPage/>
        </Suspense>
      ),
      breadcrumb: DynamicBaseBreadcrumb.DynamicBaseEditBreadcrumb,
      props: {
        commonDrawerWidth: 480
      }
    },
    {
      path: AppRoutes.ProxyServersById,
      element: (
        <Suspense fallback={ <Spinner/> }>
          <ProxyServersPage/>
        </Suspense>
      ),
      breadcrumb: DynamicProxyServersBreadcrumb.DynamicProxyServersByIdBreadcrumb,
      props: {
        commonDrawerWidth: 480
      }
    }
  ]
};
